<template>
    <div class="primary custom-flex pa-3">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        created() {
            this.auth();
        },
        methods: {
            auth() {
                if (this.$root.app.xid) {
                    this.$router.replace('/');
                }
            }
        }
    }
</script>

<style>
    .custom-flex {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
    }
</style>